var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoalFaq({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 960,
    height: 742.636,
    viewBox: "0 0 960 742.636",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-480 -168.682)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-80 -61.886)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.18,489.08c0,1.048.575,1.89,1.289,1.89h642.9c.72,0,1.289-.84,1.289-1.89s-.569-1.89-1.289-1.89H16.469C15.755,487.191,15.18,488.032,15.18,489.08Z",
    transform: "translate(700.878 482.234)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 22.954,
    height: 4.05,
    transform: "translate(926.639 965.084)",
    fill: "#b6b3c5"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 22.954,
    height: 4.05,
    transform: "translate(1129.844 965.76)",
    fill: "#b6b3c5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.9,370.945a33.074,33.074,0,0,1-65.264,0H229.146V551.874H461.387V370.945Z",
    transform: "translate(694.735 413.883)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 232.236,
    height: 6.298,
    transform: "translate(924.557 951.422)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M947.053,580.9H12.947A12.96,12.96,0,0,1,0,567.952V34.858A12.96,12.96,0,0,1,12.947,21.91H947.053A12.96,12.96,0,0,1,960,34.858V567.952A12.96,12.96,0,0,1,947.053,580.9Z",
    transform: "translate(560 208.658)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 914.094,
    height: 515.782,
    transform: "translate(581.75 251.061)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-3968.591,54.782a7.177,7.177,0,0,1-7.178-7.178,7.177,7.177,0,0,1,7.178-7.177h.151a7.177,7.177,0,0,1,7.177,7.177,7.177,7.177,0,0,1-7.177,7.178Zm.788-18.21h-1.147a3.877,3.877,0,0,1-3.872-3.873v-.963a11.853,11.853,0,0,1,1.342-5.93,31.12,31.12,0,0,1,3.759-5.049,22.268,22.268,0,0,0,2.555-3.08,5.185,5.185,0,0,0,.807-2.866c0-2.39-1.557-3.553-4.761-3.553a19.368,19.368,0,0,0-5.248.788,4.419,4.419,0,0,1-3.875-.721A4.418,4.418,0,0,1-3980,7.8V5.85a4.332,4.332,0,0,1,2.557-3.972A23.38,23.38,0,0,1-3967.912,0a23.474,23.474,0,0,1,9.2,1.711,14.847,14.847,0,0,1,6.3,4.772,11.492,11.492,0,0,1,2.259,6.966,11.322,11.322,0,0,1-2.184,6.965,39.772,39.772,0,0,1-6.1,6.221,43.63,43.63,0,0,0-3.915,3.688,6.816,6.816,0,0,0-1.628,3.031,3.861,3.861,0,0,1-3.807,3.216Z",
    transform: "translate(4925 233.349)",
    fill: "#7C3AED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14,8a1.3,1.3,0,0,0-.909.366l-7.714,7.5a1.226,1.226,0,0,0,0,1.768,1.312,1.312,0,0,0,1.818,0L14,11.018l6.805,6.616a1.312,1.312,0,0,0,1.818,0,1.226,1.226,0,0,0,0-1.768l-7.714-7.5A1.3,1.3,0,0,0,14,8Z",
    transform: "translate(1184 338)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    transform: "translate(705 343)",
    fill: "#7C3AED"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 16,
    rx: 4,
    transform: "translate(733 343)",
    fill: "#7C3AED"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 474,
    height: 12,
    rx: 4,
    transform: "translate(733 375)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 474,
    height: 12,
    rx: 4,
    transform: "translate(733 399)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 183.912,
    height: 12,
    rx: 4,
    transform: "translate(733 423)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502,.5H0A.5.5,0,0,1-.5,0,.5.5,0,0,1,0-.5H502a.5.5,0,0,1,.5.5A.5.5,0,0,1,502,.5Z",
    transform: "translate(704.5 459.5)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14,18a1.3,1.3,0,0,1-.909-.366l-7.714-7.5a1.226,1.226,0,0,1,0-1.768,1.312,1.312,0,0,1,1.818,0L14,14.982l6.805-6.616a1.312,1.312,0,0,1,1.818,0,1.226,1.226,0,0,1,0,1.768l-7.714,7.5A1.3,1.3,0,0,1,14,18Z",
    transform: "translate(1184 471)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    transform: "translate(705 476)",
    fill: "#7C3AED"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 16,
    rx: 4,
    transform: "translate(733 476)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502,.5H0A.5.5,0,0,1-.5,0,.5.5,0,0,1,0-.5H502a.5.5,0,0,1,.5.5A.5.5,0,0,1,502,.5Z",
    transform: "translate(705 505.5)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14,18a1.3,1.3,0,0,1-.909-.366l-7.714-7.5a1.226,1.226,0,0,1,0-1.768,1.312,1.312,0,0,1,1.818,0L14,14.982l6.805-6.616a1.312,1.312,0,0,1,1.818,0,1.226,1.226,0,0,1,0,1.768l-7.714,7.5A1.3,1.3,0,0,1,14,18Z",
    transform: "translate(1184 517)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    transform: "translate(705 522)",
    fill: "#7C3AED"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 16,
    rx: 4,
    transform: "translate(733 522)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502,.5H0A.5.5,0,0,1-.5,0,.5.5,0,0,1,0-.5H502a.5.5,0,0,1,.5.5A.5.5,0,0,1,502,.5Z",
    transform: "translate(704.5 551.5)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14,18a1.3,1.3,0,0,1-.909-.366l-7.714-7.5a1.226,1.226,0,0,1,0-1.768,1.312,1.312,0,0,1,1.818,0L14,14.982l6.805-6.616a1.312,1.312,0,0,1,1.818,0,1.226,1.226,0,0,1,0,1.768l-7.714,7.5A1.3,1.3,0,0,1,14,18Z",
    transform: "translate(1184 563)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    transform: "translate(705 568)",
    fill: "#7C3AED"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 16,
    rx: 4,
    transform: "translate(733 568)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502,.5H0A.5.5,0,0,1-.5,0,.5.5,0,0,1,0-.5H502a.5.5,0,0,1,.5.5A.5.5,0,0,1,502,.5Z",
    transform: "translate(705 597.5)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14,18a1.3,1.3,0,0,1-.909-.366l-7.714-7.5a1.226,1.226,0,0,1,0-1.768,1.312,1.312,0,0,1,1.818,0L14,14.982l6.805-6.616a1.312,1.312,0,0,1,1.818,0,1.226,1.226,0,0,1,0,1.768l-7.714,7.5A1.3,1.3,0,0,1,14,18Z",
    transform: "translate(1184 609)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    transform: "translate(705 614)",
    fill: "#7C3AED"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 16,
    rx: 4,
    transform: "translate(733 614)",
    fill: "#e6e6e6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoalFaq);
export default __webpack_public_path__ + "static/media/goal-faq.6e869e7de8a8a6f560a66cd1d460bea5.svg";
export { ForwardRef as ReactComponent };